import { useEffect, useState } from "react";
import { useGetProjects } from "../hooks/useGetProjects";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { t } from "i18next";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { getProject } from "../services/projectService";
import { imageFlat } from "../utils/utils";
import AddIcon from "@mui/icons-material/Add";

interface ProjectFileModal {
  onRowClick: (params: any) => void;
  selectedRowId: string[];
}

export default function ProjectFileModal({
  onRowClick,
  selectedRowId,
}: ProjectFileModal) {
  const { projectsData, isProjectsLoading } = useGetProjects();
  console.log("projectsData", projectsData.data);

  const columns: GridColDef[] = [
    {
      field: "project_name",
      renderHeader: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            pointerEvents: "none",
          }}
        >
          <Typography>{"Name"}</Typography>
        </Box>
      ),
      flex: 1,
    },
  ];

  return (
    <DataGrid
      rows={projectsData.data}
      columns={columns}
      disableColumnMenu
      disableColumnSorting
      hideFooter
      hideFooterPagination
      autoHeight
      onRowClick={onRowClick}
      getRowClassName={
        (params) => (params.row.id === selectedRowId ? "selected-row" : "") // 선택된 행의 클래스 설정
      }
      sx={{
        "& .MuiDataGrid-columnHeader": {
          pointerEvents: "none", // 헤더에 마우스 포인터 효과 제거
        },
        "& .MuiDataGrid-cell": {
          cursor: "pointer", // 데이터 셀에 포인터 효과 추가
        },
        "& .MuiDataGrid-columnHeader:focus": {
          outline: "none", // 헤더의 아웃라인 제거
        },
        "& .MuiDataGrid-columnHeader:focus-within": {
          outline: "none", // 헤더의 포커스 상태 아웃라인 제거
        },
        "& .selected-row": {
          backgroundColor: "lightblue", // 선택된 행의 배경색 설정
        },
      }}
    />
  );
}
